<template>
  <div class="password-field-container">
    <input
      v-model="password"
      class="form-control input-no-border"
      :autocomplete="disableAutocomplete ? 'new-password' : 'nope'"
      :required="required"
      :placeholder="placeholder"
      :type="isPasswordView ? 'text' : 'password'"
    >
    <span
      class="eye-icon"
      @click="isPasswordView = !isPasswordView"
    ><i :class="isPasswordView ? 'fa fa-eye-slash' : 'fa fa-eye'" /></span>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, type WritableComputedRef } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },

  placeholder: {
    type: String,
    default: '',
  },

  required: {
    type: Boolean,
    default: true,
  },

  disableAutocomplete: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const password: WritableComputedRef<string> = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

const isPasswordView = ref(false);
</script>

<style lang="scss">
.password-field-container {
  display: flex;
  &.invalid {
    input.form-control {
      background-color: #fdf2b5;
      border: 1px solid #c7c98b !important;
    }
  }
  input.form-control {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .eye-icon {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #c1c1c1;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    cursor: pointer;
    background-color: #f3f2ee;
    color: #252422;
    border: 1px solid #ddd;
    border-left: 0;
    &:hover {
      color: #075563;
    }
  }
}
</style>
